








































import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import UrlMixin from '@/mixins/url';

import HiddenField from '@/components/Atoms/Input/HiddenField.vue';
import SubmitButton from '@/components/Atoms/Button/SubmitButton.vue';
import { VasConfig } from '@/data/vasConfig';
import { HikariConfig } from '@/data/hikariConfig';

@Component({
  components: { SubmitButton, HiddenField },
})
export default class ApplyForm extends mixins(UrlMixin) {
  private formName = 'no_auth_hikari_estimate_apply_form';
  private vasConfig = new VasConfig();

  @Prop({ default: false }) disabled?: boolean;
  @Prop() config!: HikariConfig;

  get building() {
    return this.$store.getters['hikari/building'];
  }

  get entryType() {
    return this.$store.getters['hikari/entryType'];
  }

  get currentUsageType() {
    return this.$store.getters['hikari/currentUsageType'];
  }

  get applyType() {
    return this.$store.getters['hikari/applyType'];
  }

  get phonePlan() {
    return this.$store.getters['hikari/phonePlan'];
  }

  get router() {
    return this.$store.getters['hikari/router'];
  }

  get phoneOptions() {
    return this.$store.getters['hikari/phoneOptions'];
  }

  get staticIp() {
    return this.$store.getters['hikari/staticIp'];
  }

  get vas() {
    return this.$store.getters['vas/find']({});
  }

  get initialTotalAmount(): number {
    return (
      Number(this.$store.getters['vas/initialTotalAmount']) +
      Number(this.$store.getters['hikari/initialTotalAmount'](this.config))
    );
  }

  get totalAmountOfMonth(): number {
    return (
      Number(this.$store.getters['vas/totalAmountOfMonth']) +
      Number(this.$store.getters['hikari/totalAmountOfMonth'](this.config))
    );
  }

  vasInputFieldName(item: any): string {
    const vas = this.vasConfig.getVas(item.id);
    return `${this.formName}[vas][${vas.categoryId}][${item.id}]`;
  }
}
